import React from 'react';

type Props = {
    message   : string
    close     : callback
    fadeTime  : number
}

export default function ErrorMessage(props:Props) {

    const classes = Classes("ui5-pale-bg notification ", "h-100-percent", "error")

    return (
        <div className={Classes(classes)} style={{transition: "opacity " + props.fadeTime + "s"}}>
            <div className="flex-row-left-center">
                <div className="left-indicator"></div>
                <div className="i5-emergency-solid icon ui5-color-red m-l-3"/>
                <div className="message ui5-txt-less-important">
                    {props.message}
                </div>
            </div>
            <div className="close i5-delete" onClick={props.close}/>
        </div>
    )

}
